import type { RouteRecordRaw } from 'vue-router'

export const procurementRoutes: RouteRecordRaw[] = [
  {
    path: '/procurements',
    name: 'procurements',
    component: () => import('@/modules/post-mvp/procurement/views/ProcurementsView.vue'),
    meta: {
      title: 'Закупки',
      requiresAuth: true,
      requiresFeature: 'procurement_enabled',
    },
  },
  {
    path: '/procurements/create',
    name: 'procurement-create',
    component: () => import('@/modules/post-mvp/procurement/views/CreateProcurementView.vue'),
    meta: {
      title: 'Создание закупки',
      requiresAuth: true,
      requiresFeature: 'procurement_enabled',
    },
  },
  {
    path: '/procurements/:id/edit',
    name: 'procurement-edit',
    component: () => import('@/modules/post-mvp/procurement/views/CreateProcurementView.vue'),
    meta: {
      title: 'Редактирование закупки',
      requiresAuth: true,
      requiresFeature: 'procurement_enabled',
    },
    props: true,
  },
  {
    path: '/procurements/:id',
    name: 'procurement-details',
    component: () => import('@/modules/post-mvp/procurement/views/ProcurementDetailsView.vue'),
    meta: {
      title: 'Детали закупки',
      requiresAuth: true,
      requiresFeature: 'procurement_enabled',
    },
    props: true,
  },
  {
    path: '/procurements/:id/offers',
    name: 'procurement-offers',
    component: () => import('@/modules/post-mvp/procurement/views/OfferListView.vue'),
    meta: {
      title: 'Предложения по закупке',
      requiresAuth: true,
      requiresFeature: 'procurement_enabled',
    },
    props: true,
  },
  {
    path: '/procurements/:procurementId/offers/create',
    name: 'offer-create',
    component: () => import('@/modules/post-mvp/procurement/views/OfferFormView.vue'),
    meta: {
      title: 'Подача предложения',
      requiresAuth: true,
      requiresFeature: 'procurement_enabled',
    },
    props: true,
  },
  {
    path: '/procurements/:id/comparison',
    name: 'procurement-comparison',
    component: () => import('@/modules/post-mvp/procurement/views/WinnerSelectionView.vue'),
    meta: {
      title: 'Выбор победителей',
      requiresAuth: true,
      requiresFeature: 'procurement_enabled',
    },
    props: true,
  },
  {
    path: '/procurements/:id/results',
    name: 'procurement-results',
    component: () => import('@/modules/post-mvp/procurement/views/ProcurementDetailsView.vue'),
    meta: {
      title: 'Результаты закупки',
      requiresAuth: true,
      requiresFeature: 'procurement_enabled',
    },
    props: true,
  },
  {
    path: '/offers/:offerId',
    name: 'offer-details',
    component: () => import('@/modules/post-mvp/procurement/views/OfferDetailsView.vue'),
    meta: {
      title: 'Детали предложения',
      requiresAuth: true,
      requiresFeature: 'procurement_enabled',
    },
    props: true,
  },
  {
    path: '/offers/:offerId/edit',
    name: 'offer-edit',
    component: () => import('@/modules/post-mvp/procurement/views/OfferFormView.vue'),
    meta: {
      title: 'Редактирование предложения',
      requiresAuth: true,
      requiresFeature: 'procurement_enabled',
    },
    props: true,
  },
  {
    path: '/procurement-analytics',
    name: 'procurement-analytics',
    component: () => import('@/modules/post-mvp/procurement/views/ProcurementAnalyticsView.vue'),
    meta: {
      title: 'Аналитика закупок',
      requiresAuth: true,
      requiresFeature: 'procurement_enabled',
    },
  },
]

export function createProcurementRoutes(): RouteRecordRaw[] {
  return procurementRoutes
}
